import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { DesktopView } from './desktop/Created.desktop';
import { MobileView } from './mobile/Created.mobile';
import { ChildProfilePageStep, CommonPageStep } from '../..';
import { useAppSelector } from '../../../store/hooks';
import {
  selectAppAuthentication,
  selectAppPageStep,
  setAppPageStep,
} from '../../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../../store/store';

export const Created = (): JSX.Element => {
  // Redux Hooks
  const pageStep = useAppSelector(selectAppPageStep);
  const authenticationData = useAppSelector(selectAppAuthentication);

  React.useEffect(() => {
    outsideComponentDispatch(setAppPageStep(ChildProfilePageStep.CREATED));
  }, []);

  return (
    <React.Fragment>
      <DesktopView />
    </React.Fragment>
  );
};
